var $ = jQuery;

export default class Print {

	ready() {

		$(document).on('click', '.print', function(e){

			window.print();

			e.preventDefault();

		});

    }
}